import { Suspense, type ErrorInfo } from "react";
import type { AppRouter } from "@/router";
import AppLoadingScreen from "@/components/organisms/appLoadingScreen";
import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { AppRootErrorFallbackAppLevel } from "@/components/organisms/appRootErrorFallbackAppLevel";
import { ToastProvider } from "@/contexts/ToastContext";
import { CatalogAndSearchIndexMount } from "@/components/organisms/catalogAndSearchIndexMount";

const logAppLevelErrorBoundary = (error: unknown, info: ErrorInfo) => {
  console.error("App-level ErrorBoundary:", error, info);
};

type AppProps = {
  router: AppRouter;
};

const App = ({ router }: AppProps) => {
  return (
    <ErrorBoundary
      FallbackComponent={AppRootErrorFallbackAppLevel}
      onError={logAppLevelErrorBoundary}
    >
      <ToastProvider>
        <CatalogAndSearchIndexMount />
        <Suspense fallback={<AppLoadingScreen />}>
          <RouterProvider router={router} />
        </Suspense>
      </ToastProvider>
    </ErrorBoundary>
  );
};

export default App;
